import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import { required } from '.';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched && ((error && <span className="error-text"> ({error})</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const EmailForm = (props) => {
  const { handleSubmit, pristine, reset, submitting, cancel } = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="name"
            type="text"
            component={renderBootstrapField}
            label="Name"
            validate={required}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="email"
            type="text"
            component={renderBootstrapField}
            label="Email"
            validate={required}
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={submitting}
              bsStyle="success"
              type="submit"
            >
              <i className="fa fa-envelope fa-lg" /> Send
            </Button>
            {cancel && (
            <Button
              disabled={submitting}
              bsStyle="danger"
              onClick={cancel}
            >
              <i className="fa fa-times fa-lg" /> Cancel
            </Button>
            )}
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'EmailForm', // a unique identifier for this form
})(EmailForm);



// WEBPACK FOOTER //
// src/forms/EmailForm.js